import { Box, Typography, Button, Avatar } from "@mui/material";
import { ReceiptLong, Add } from "@mui/icons-material";

export default function TaskWork({
  title = "Завдання для операторів",
  activeCount = 0,
  onAdd,
}) {
  return (
    <Box
      sx={{
        backgroundColor: "#6c63ff",
        borderRadius: 2,
        px: 3,
        py: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography variant="h6" fontWeight="bold" color="white" mb={1}>
          {title}
        </Typography>
        <Box display="flex" alignItems="center" gap={2}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<Add sx={{ color: "white" }} />}
            sx={{ color: "white", borderColor: "white", textTransform: "none" }}
            onClick={onAdd}
          >
            <Typography variant="subtitle1" style={{ color: "white" }}>
              {" "}
              Додати{" "}
            </Typography>
          </Button>
          <Typography
            variant="subtitle1"
            style={{ color: "white", fontSize: 14 }}
          >
            Активовано: {activeCount}
          </Typography>
        </Box>
      </Box>
      <Avatar
        sx={{ bgcolor: "white", color: "#6c63ff", width: 40, height: 40 }}
      >
        <ReceiptLong />
      </Avatar>
    </Box>
  );
}
